import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { AuthService } from '../services/auth.service';

export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
	const auth = inject(AuthService);
	const router = inject(Router);

	// Clone the request and add the authorization header if token exists
	let authReq = req;
	if (auth.currentToken() && req.url.startsWith(environment.apiUrl)) {
		authReq = req.clone({
			setHeaders: { Authorization: `Bearer ${ auth.currentToken() }` }
		});
	}

	// Send the request and handle errors
	return next(authReq).pipe(
		catchError((error) => {
			if (error.status === 401) {
				auth.logout();
				router.navigate(['account', 'login']);
			}
			return throwError(() => error);
		})
	);
};
